import injector from 'vue-inject'

/**
 * Service use for sites and users administration
 */
class AdminService {
  constructor(axios, apiRoot) {
    this.axios = axios
    this.apiRoot = apiRoot
  }

  /**
   * Return all users
   */
  async getAllUsers() {
    const url = `${this.apiRoot}/users`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Create a new user
   * @param {*} userForm
   */
  async createUser(userForm) {
    const url = `${this.apiRoot}/users/add`
    return this.axios.post(url, userForm).then(response => response.data)
  }

  /**
   * Update a current user
   * @param {*} userForm
   */
  async updateUser(userForm) {
    const url = `${this.apiRoot}/users/update`
    return this.axios.post(url, userForm).then(response => response.data)
  }

  /**
   * Delete a user according to his ID
   * @param {*} userId
   */
  async deleteUser(userId) {
    const url = `${this.apiRoot}/users/delete`
    return this.axios.delete(url, { data: { id: userId } }).then(response => response.data)
  }

  /**
   * Return all sites
   */
  async getAllSites() {
    const url = `${this.apiRoot}/sites`
    return this.axios.get(url).then(response => response.data.result)
  }

  /**
   * Create a new site
   * @param {*} siteForm
   */
  async getAllSitesWithSurvey() {
    const url = `${this.apiRoot}/sites/survey`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Create a new site
   * @param {*} siteForm
   */
  async getAllSitesWithMaps() {
    const url = `${this.apiRoot}/sites/map`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Create a new site
   * @param {*} siteForm
   */
  async createSite(siteForm) {
    const url = `${this.apiRoot}/sites/add`
    return this.axios.post(url, siteForm).then(response => response.data)
  }

  /**
   * Update a current site
   * @param {*} siteForm
   */
  async updateSite(siteForm) {
    const url = `${this.apiRoot}/sites/update`
    return this.axios.post(url, siteForm).then(response => response.data)
  }

  /**
   * Delete a site according to his ID
   * @param {*} siteId
   */
  async deleteSite(siteId) {
    const url = `${this.apiRoot}/sites/delete`
    return this.axios.delete(url, { data: { id: siteId } }).then(response => response.data)
  }

  /**
   * Return site accordin to his ID
   * @param {*} siteId
   */
  async getSite(siteId) {
    const url = `${this.apiRoot}/sites/${siteId}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Unsubscribe a visitor's email
   * @param {*} uid
   */
  async unsubscribeEmail(uid) {
    const url = `${this.apiRoot}/unsubscription?uid=${uid}`
    return this.axios.get(url).then(response => response.data)
  }
}

injector.service('adminService', ['axios', 'apiRoot'], AdminService)
